import React from "react";
import { SchedulesOverview, ScheduleDetails } from ".";
import { Loading, DisplayBox } from "../../components";
import { ApiHelper, ArrayHelper, ScheduleTimeInterface, ScheduleInterface, ScreenInterface, SchedulePlaylistInterface, PlaylistInterface } from "../../helpers";

interface Props {
  screen: ScreenInterface
}

export const Schedules: React.FC<Props> = props => {

  const [schedules, setSchedules] = React.useState<ScheduleInterface[]>(null);
  const [scheduleTimes, setScheduleTimes] = React.useState<ScheduleTimeInterface[]>(null);
  const [selectedSchedule, setSelectedSchedule] = React.useState<ScheduleInterface>(null);
  const [schedulePlaylists, setSchedulePlaylists] = React.useState<SchedulePlaylistInterface[]>([]);
  const [playlists, setPlaylists] = React.useState<PlaylistInterface[]>([]);

  const init = () => { loadData(); }

  const loadData = async () => {
    setSelectedSchedule(null);

    ApiHelper.get("/playlists/available").then(p => setPlaylists(p));

    if (props.screen?.id > 0) {
      ApiHelper.get("/schedulePlaylists/screen/" + props.screen.id).then(sp => setSchedulePlaylists(sp));
      const scheduleData = await ApiHelper.get("/schedules/screen/" + props.screen?.id);
      const scheduleIds = ArrayHelper.getIds(scheduleData, "id")
      setSchedules(scheduleData);
      if (scheduleIds.length > 0) {
        const scheduleTimeData = await (ApiHelper.get("/scheduleTimes/scheduleIds?scheduleIds=" + scheduleIds.join(",")));
        setScheduleTimes(scheduleTimeData);
      } else setScheduleTimes([]);
    } else {
      setSchedules([]);
      setScheduleTimes([]);
    }
  }

  const handleAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    setSelectedSchedule({ screenId: props.screen?.id });
  }

  const getAddLink = () => {
    return <a className="float-right text-success" href="about:blank" onClick={handleAdd}>
      <i className="fas fa-plus"></i> Add Schedule
    </a>
  }

  const getPlaylistsNames = (scheduleId: number) => {
    const result: string[] = [];
    console.log("Schedule playlists")
    console.log(schedulePlaylists);
    const sp = ArrayHelper.getAll(schedulePlaylists, "scheduleId", scheduleId);
    if (sp.length > 0) {
      const playlistIds = ArrayHelper.getIds(sp, "playlistId");
      const ps = ArrayHelper.getAllArray(playlists, "id", playlistIds)
      ps.forEach(p => result.push(p.name));
    }
    if (result.length === 0) result.push("None");

    return (<><br /><span style={{ color: "#999", fontSize: 13 }}>{result.join(", ")}</span></>);
  }

  const getSchedules = () => {
    const result: JSX.Element[] = []
    schedules.forEach(s => {
      result.push(<li>
        <a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedSchedule(s); }}>{s.name || "(no name)"}</a>
        {getPlaylistsNames(s.id)}
      </li>)
    })
    return result;
  }

  const handleScheduleUpdated = () => {
    setSelectedSchedule(null);
    init();
  }

  const getDetails = () => {
    if (selectedSchedule) {
      const st: ScheduleTimeInterface[] = (scheduleTimes) ? ArrayHelper.getAll(scheduleTimes, "scheduleId", selectedSchedule.id) : null;
      return (<ScheduleDetails screen={props.screen} schedule={selectedSchedule} scheduleTimes={st} updatedCallback={handleScheduleUpdated} />)
    }
    else return (<></>);
  }

  React.useEffect(init, [props.screen?.id]) // eslint-disable-line

  if (schedules === null) return <Loading />
  else return (
    <>
      <DisplayBox headerIcon="far fa-clock" headerText="Schedules" editContent={getAddLink()} >
        <ul>
          {getSchedules()}
        </ul>
        <SchedulesOverview schedules={schedules} scheduleTimes={scheduleTimes} />
      </DisplayBox>
      {getDetails()}
    </>
  );
};